import Vue from 'vue'
import Vuelidate from 'vuelidate'
import store from './store.js'
import moment from 'moment'
import router from './routes/index'
import IndexPage from './views/index'
import { i18n } from './lang'
import './axiosConfig'
import { sendError } from './utils/logging'
import DebugLogger from './components/debug/DebugLogger.vue'
import debugLogger from './utils/DebugLoggerSDK'

import VueAgile from 'vue-agile'
import 'es6-promise/auto'
import 'vue-switch/switch.css'

if (typeof window !== 'undefined') {
  const cssPath = '/landingpages/assets/dist/static/css/style.css'
  const existingLink =
    document.querySelector(`link[href="${cssPath}"]`) ||
    document.querySelector('link[href*="style.css"]')

  if (!existingLink) {
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = cssPath
    document.head.appendChild(link)
    console.log('[ES Modules] Injected CSS link:', cssPath)
  }
}

Vue.config.errorHandler = (err, vm, info) => {
  if (window.self !== window.top) {
    return
  }
  const stack = err.stack.split('\n')
  const errorPayload = JSON.stringify({
    error: {
      stack,
      message: err.message,
      name: err.name,
      description: err.description,
      number: err.number,
      fileName: err.fileName,
      lineNumber: err.lineNumber,
      columnNumber: err.columnNumber,
    },
    info,
    url: window.location.href,
  })
  sendError(errorPayload)
}

Vue.config.warnHandler = function (msg, vm, trace) {
  if (window.self !== window.top) {
    return
  }
  const errorPayload = JSON.stringify({
    message: msg,
    trace,
    url: window.location.href,
  })
  sendError(errorPayload)
}

Vue.prototype.moment = moment
window.moment = moment

Vue.prototype.$eventHub = new Vue()
Vue.config.productionTip = false
Vue.config.devtools = true
Vue.use(Vuelidate)
Vue.use(VueAgile)

console.log(`Captive portal version ${process.env.VERSION}`)

const urlParams = new URLSearchParams(window.location.search)
const isDevPortal = window.location.hostname === 'portal.mywifi-dev.io'
const debugParam = urlParams.get('debug')

const isDebugMode = debugParam === null ? isDevPortal : debugParam === '1'
sessionStorage.setItem('is_debug', isDebugMode)

// Store device type from query parameters (is_mobile=1 or is_desktop=1)
const isMobileParam = urlParams.get('is_mobile')
const isDesktopParam = urlParams.get('is_desktop')
if (isMobileParam === '1') {
  sessionStorage.setItem('is_mobile', '1')
  sessionStorage.removeItem('is_desktop')
} else if (isDesktopParam === '1') {
  sessionStorage.setItem('is_desktop', '1')
  sessionStorage.removeItem('is_mobile')
}

const app = new Vue({
  el: '#app',
  components: { IndexPage, DebugLogger },
  template: '<div><DebugLogger/><IndexPage/></div>',
  store,
  router,
  i18n,
})

export default app
